import { Box, Flex, Text, TextButton } from '@modusign/design-system';
import { useTranslation } from 'react-i18next';

interface DesktopAttachmentListItemProps {
  enableDownload: boolean;
  attachmentType?: string;
  fileName: string | null;
  participantName: string;
  onDownload: () => void;
  onOpen: () => void;
}

function DesktopAttachmentListItem({
  enableDownload = true,
  attachmentType,
  fileName,
  participantName,
  onDownload,
  onOpen,
}: DesktopAttachmentListItemProps) {
  const { t } = useTranslation();

  return (
    <Box as="tr" borderBottom="1px solid" borderBottomColor="lightGray500">
      <Box as="td">
        <Text display="block" ellipsis px={7} py={6} sx={{ flex: 'auto' }}>
          {participantName}
        </Text>
      </Box>
      <Box as="td">
        <Flex as="span" px={7} py={6}>
          <Text display="inline-block" ellipsis fontWeight="medium" mr={8} sx={{ flex: 'auto' }}>
            {attachmentType && `${attachmentType} / `}
            {fileName}
          </Text>
          <Box flex="none">
            <TextButton onClick={onOpen}>{t('Global-view')}</TextButton>
            {enableDownload && (
              <TextButton ml={7} onClick={onDownload}>
                {t('Global-download')}
              </TextButton>
            )}
          </Box>
        </Flex>
      </Box>
    </Box>
  );
}

export default DesktopAttachmentListItem;
